// Central place for the CAMITEX WhatsApp number and message builders.
// Previously the number was copy-pasted across ProductDetail, App, Checkout, etc.

export const WHATSAPP_NUMBER = '50687839222';

/**
 * wa.me link with a pre-filled, URL-encoded message.
 * @param {string} message
 * @returns {string}
 */
export const whatsappUrl = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

/**
 * "Consult the price of this product" link, used everywhere a price is hidden
 * while Catalogue Mode is on.
 * @param {{ codigo?: string, nombre?: string, extra?: string }} product
 * @returns {string}
 */
export const priceConsultUrl = ({ codigo, nombre, extra = '' } = {}) => {
  const label = [codigo, nombre].filter(Boolean).join(' - ') || 'un producto del catálogo';
  return whatsappUrl(`Hola, quiero consultar el precio de: ${label}${extra}`);
};

/**
 * "Consult prices for this list of products" link, used by the cart in
 * Catalogue Mode instead of checkout.
 * @param {Array<{codigo?:string, nombre?:string, color_name?:string, talla_id?:string|number, quantity?:number}>} items
 * @returns {string}
 */
export const cartConsultUrl = (items = []) => {
  const lines = items.map((item) => {
    const name = [item.codigo, item.nombre].filter(Boolean).join(' ');
    const attrs = [
      item.color_name ? `Color: ${item.color_name}` : null,
      item.talla_id ? `Talla: ${item.talla_id}` : null,
    ].filter(Boolean).join(', ');
    const qty = item.quantity ? ` x${item.quantity}` : '';
    return `- ${name}${attrs ? ` (${attrs})` : ''}${qty}`;
  });
  return whatsappUrl(
    `Hola, quiero consultar precios de estos productos:\n${lines.join('\n')}`
  );
};
